import {HttpClient} from '@angular/common/http';
import {LOCALE_ID, NgModule} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';

import {
	TranslateLoader,
	TranslateModule as NgxTranslateModule,
} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {I18N_VERSION} from './i18n-version';

registerLocaleData(localeFr);
registerLocaleData(localeEn);

/**
 * The translation files are cache-busted with `I18N_VERSION` (see
 * `./i18n-version.ts`), a value that is STABLE within a deployment and only
 * changes on a new release — it is stamped from the git tag by CI at build time.
 *
 * Using `Date.now()` here (a value that changes on every page load) would make
 * the URL unique each time, so the browser would never cache the translation
 * files and would re-download them on every reload — slow on poor connections.
 * A per-release token lets the browser serve them from cache between reloads
 * while still busting the cache when a new version is deployed.
 */
export function httpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(
		http,
		'assets/i18n/',
		`.json?v=${I18N_VERSION}`
	);
}

@NgModule({
	imports: [
		NgxTranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: httpLoaderFactory,
				deps: [HttpClient],
			},
		}),
	],
	providers: [{provide: LOCALE_ID, useValue: 'fr-FR'}],
	exports: [NgxTranslateModule],
})
export class TranslateModule {}
